import { useEffect, useReducer, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Card, CardContent, CardHeader, Stack } from "@mui/material";
import { createRole, roleState, roleStateMange, updateRole } from "./roleData";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { useLoading } from "../../../../context/LodingContext";
import MaterialTypography from "../../../../components/MaterialTypography";
import { MdAdminPanelSettings } from "react-icons/md";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";

import Swal from "sweetalert2";
import request from "graphql-request";
import BASEURL from "../../../../pages/Utils/Baseurl";

const RoleCreateForm = () => {
  const [roleData, dispatch] = useReducer(roleStateMange, roleState);
  const [inputDisble, setInputDisble] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { setCirleLoading } = useLoading();

  const formType = location?.state?.type;
  const formValue = location?.state?.data;

  useEffect(() => {
    if (formValue) {
      dispatch({
        value: formValue?.role,
        name: "role",
      });
      dispatch({
        value: formValue?.description,
        name: "description",
      });
    }
  }, [formValue]);

  useEffect(() => {
    if (formType == "view") {
      setInputDisble(true);
    } else {
      setInputDisble(false);
    }
  }, [formType]);

  const handleAdd = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, createRole, {
        input: {
          role: roleData?.role,
          description: roleData?.description,
        },
      });
      const status = res?.createRole?.success;
      const message = res?.createRole?.message;
      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: "Successfully Created",
          showConfirmButton: true,
        }).then(() => {
          navigate("/role/rolecreate");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };

  const handleUpdate = async () => {
    setCirleLoading(true);
    try {
      const res = await request(BASEURL, updateRole, {
        input: {
          id: formValue?.id,
          role: roleData?.role,

          description: roleData?.description,
        },
      });

      const status = res?.updateRole?.success;
      const message = res?.updateRole?.message;
      if (status) {
        Swal.fire({
          position: "top",
          icon: "success",
          title: "Successfully updated",
          showConfirmButton: true,
        }).then(() => {
          navigate("/role/rolecreate");
        });
      } else {
        Swal.fire({
          position: "top",
          icon: "error",
          title: message,
          showConfirmButton: true,
        });
      }
    } catch (err) {
    } finally {
      setCirleLoading(false);
    }
  };
  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  {formType == "add"
                    ? "Add Role Details"
                    : formType == "edit"
                    ? "Edit Role Details"
                    : "View Role Details"}
                </MaterialTypography>
              </Stack>
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <MdAdminPanelSettings style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Role Information
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Role Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={roleData?.role}
                  name="role"
                  placeholder="Enter Role Name"
                  disabled={inputDisble}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "role" })
                  }
                  error={roleData.roleStatus === "error" ? true : false}
                  success={roleData.roleStatus === "success" ? true : false}
                />
              </Grid>

              <Grid size={{ lg: 6, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Description
                  </MaterialTypography>
                </MaterialBox>

                <textarea
                  value={roleData?.description}
                  name="description"
                  placeholder="Enter Description"
                  style={{
                    width: "100%",
                    height: "100px",
                    borderRadius: "10px",
                    borderColor:
                      roleData.descriptionStatus === "success"
                        ? "#66d432"
                        : roleData.descriptionStatus === "error"
                        ? "#fd5c70"
                        : "#d2d6da",
                    padding: "10px",
                    outline: "none",
                  }}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "description" })
                  }
                  disabled={inputDisble}
                />
              </Grid>
            </Grid>
          </MaterialBox>

          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={() => navigate(-1)}
            >
              Cancel
            </MaterialButton>
            {formType != "view" && (
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                // disabled={!checkAllFields()}
                onClick={formType == "add" ? handleAdd : handleUpdate}
              >
                {formType == "add" ? "Submit" : "Update"}
              </MaterialButton>
            )}
          </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default RoleCreateForm;
